var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrystal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.87303 3H19.127C19.2848 2.99998 19.4404 3.0373 19.581 3.1089C19.7216 3.18051 19.8433 3.28437 19.936 3.412L23.759 8.668C23.827 8.76152 23.8605 8.8757 23.8537 8.99112C23.847 9.10653 23.8004 9.21603 23.722 9.301L12.367 21.602C12.2771 21.6992 12.1522 21.7568 12.0198 21.7621C11.8875 21.7673 11.7584 21.7198 11.661 21.63C11.654 21.624 7.86103 17.515 0.278033 9.301C0.199637 9.21603 0.153106 9.10653 0.14636 8.99112C0.139614 8.8757 0.17307 8.76152 0.241033 8.668L4.06403 3.412C4.15681 3.28437 4.27848 3.18051 4.41908 3.1089C4.55969 3.0373 4.71524 2.99998 4.87303 3ZM5.38303 5L2.58303 8.85L12 19.05L21.417 8.85L18.617 5H5.38303Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrystal);
export default __webpack_public_path__ + "static/media/crystal.6b997b5ae1a130606516eb13d634d913.svg";
export { ForwardRef as ReactComponent };